/**
 * objects operations
 * 
 * @author    Jens Gruschel
 * @copyright © 2019 contexagon GmbH
 */


import {fetchJSONActivity} from "./communication";
import {
    REST_CALL_OBJECT_LIST,
    REST_CALL_OBJECT_QUERY,
    REST_SERVER_BASE_URL
} from "../config";


/**
 * make sure only non-deleted objects are returned (except for queries explicitely including deleted objects)
 * @param {Object} query    database query definition
 * @returns {Object}        patched query definition
 * @author Jens Gruschel
 */
export function excludeDeleted(query) {
    return {"timestamp-deleted": { $exists: false }, ...query};
}

/**
 * fetch a simple list of objects from the server
 * @param {*} dispatch 
 * @param {*} getState 
 * @param {Object} query    database query definition
 * @param {*} orderBy       optional database ordering definition
 * @returns {Array}         list of objects
 * @author Jens Gruschel
 */
export async function fetchObjectList(dispatch, getState, query, orderBy = undefined)
{
    // build request
    const request = orderBy ? {$query: query, $orderby: orderBy} : query;
    console.log("search request:", request, JSON.stringify(request));

    // do server communication
    const { authorization } = getState();
    const response = await fetchJSONActivity(dispatch, "searching objects",
        REST_SERVER_BASE_URL + REST_CALL_OBJECT_LIST.path, {
            method: REST_CALL_OBJECT_LIST.method,
            body: JSON.stringify(request),
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + authorization.accessToken
            }
        }
    );

    return response.items;
}

/**
 * fetch a list of objects from the server including access levels and reference counts
 * @param {*} dispatch 
 * @param {*} getState 
 * @param {Object} query    database query definition
 * @param {*} orderBy       optional database ordering definition
 * @returns {Object}        object containing object array plus additional information
 * @author Jens Gruschel
 */

export async function fetchObjectQuery(dispatch, getState, query, orderBy = undefined)
{
    // build request
    const request = orderBy ? {$query: query, $orderby: orderBy} : query;
    console.log("search request:", request, JSON.stringify(request));

    // do server communication
    const { authorization } = getState();
    const response = await fetchJSONActivity(dispatch, "searching objects",
        REST_SERVER_BASE_URL + REST_CALL_OBJECT_QUERY.path, {
            method: REST_CALL_OBJECT_QUERY.method,
            body: JSON.stringify(request),
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + authorization.accessToken
            }
        }
    );

    return response;
}